import { EventCreatorMap } from '@app/analytics/models/helpers';

import EventAlertCreateSuccess from './alert';
import EventApplyFilter from './apply-filter';
import EventClickResults from './click-results';
import EventClickSeoLinks from './seo-links';

import * as CatalogActions from '@app/+catalog/store/actions/catalog.action';

const eventsMap: EventCreatorMap = {
  [CatalogActions.CREATE_ALERT_SUCCESS]: EventAlertCreateSuccess,
  [CatalogActions.APPLY_FILTER]: EventApplyFilter,
  [CatalogActions.TRACK_PRODUCT_CLICK]: EventClickResults,
  [CatalogActions.TRACK_SEO_LINK_CLICK]: EventClickSeoLinks
};

export default eventsMap;
